'use client'
import { Button } from '@components/ui/button/Button'
import { paths } from '@router/paths'
import { useRouter } from 'next/navigation'
import { navigateWithState } from '@utils/navigation.utils'

export const CtaButtons = () => {
  const router = useRouter()
  return (
    <div className="flex gap-4 sm:gap-6 justify-center mt-11">
      <Button
        variant="green"
        size="lg"
        className="py-3 px-6 sm:px-8"
        onClick={() => {
          navigateWithState(
            paths.funds.exclusiveAccess.companies,
            { hash: 'pre-ipo-access', scrollPosition: 'start' },
            router,
          )
        }}
      >
        Invest from $20
      </Button>
      <Button
        variant="secondaryWhite"
        size="lg"
        className="py-3 px-6 sm:px-8"
        onClick={() =>
          navigateWithState(
            paths.funds.exclusiveAccess.companies,
            { hash: 'what-is-pre-ipo', scrollPosition: 'center' },
            router,
          )
        }
      >
        How it works?
      </Button>
    </div>
  )
}
